// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFastForwardOutlinedSvg from "@fishx/icons-svg/es/asn/PFastForwardOutlined";
import FishxIcon from '../components/FishxIcon';

var PFastForwardOutlined = function PFastForwardOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFastForwardOutlinedSvg
  }));
};

PFastForwardOutlined.displayName = 'PFastForwardOutlined';
export default React.forwardRef(PFastForwardOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFastForwardOutlined.js
// module id = 3373
// module chunks = 0